import { tv, VariantProps } from "@/utils";

export const radio = tv({
  slots: {
    base: ["relative"],
    label: ["cursor-pointer", "ms-2"],
    group: ["flex items-center"],
    input: ["cursor-pointer", "w-4 h-4", "rounded-full", "focus:ring-2"],
  },
  variants: {
    color: {
      dark: {
        input: [
          "text-primary-100 border-gray-100 focus:ring-primary-100/50 focus:border-primary-100 checked:border-primary-100",
        ],
      },
      light: {
        input: [
          "text-primary-500 border-gray-400 focus:ring-primary-500/50 focus:border-primary-500 checked:border-primary-500",
        ],
      },
    },
    hasError: {
      true: {
        input: [
          "border-red-500 focus:ring-red-500/50 focus:border-red-500 checked:border-red-500",
        ],
      },
    },
  },
  compoundSlots: [
    {
      slots: ["label", "input"],
      hasError: true,
      className: "text-red-500",
    },
  ],
  defaultVariants: {
    color: "dark",
    hasError: false,
  },
});

export type RadioVariantProps = VariantProps<typeof radio>;

export type RadioReturnVariantProps = ReturnType<typeof radio>;
